import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HomePage } from './home.page';
import { SharedModuleModule } from '../../shared-module/shared-module.module';
import { AddToHomeComponent } from '../../components/add-to-home/add-to-home.component';
import { HomePreorderTypeButtonComponent } from '../../components/home-preorder-type-button/home-preorder-type-button.component';
import { HomePageSlidesComponent } from '../../components/home-page-slides/home-page-slides.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: HomePage,
			},
		]),
		SharedModuleModule,
	],
	declarations: [HomePage, AddToHomeComponent, HomePreorderTypeButtonComponent, HomePageSlidesComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageModule {}
